module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/classic-tee/15-91797619d3e7a7851f06efd0af064862.jpg";